import React, {useContext, useRef} from "react";
import {Link, useHistory, useParams} from "react-router-dom";

import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles} from "../../atom/Apollo_styles";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {apollo_user_path, get_apollo_role_path, signin_path} from "../../atom/Apollo_links";
import {ApolloContext} from "../../atom/Apollo_Context";
import {Attention, DeleteButton} from "../../molecule/Apollo_Button";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_OPERATOR, ApolloPageUsagePermission, IsAuthorization} from "../../atom/Apollo_Authorization";
import {DetailUser, RoleInfo} from "./UserModel";

import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import Fab from "@material-ui/core/Fab";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Grid from "@material-ui/core/Grid";
import EditIcon from '@material-ui/icons/Edit';
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Collapse from "@material-ui/core/Collapse/Collapse";
import Tooltip from '@material-ui/core/Tooltip';
import Button from "@material-ui/core/Button";

import moment from "moment";
// メッセージ定義
import {
  GetMessage,
  UI_USER_DETAIL,
} from "../../atom/Apollo_MesasgeDefinition";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";

const initUser: DetailUser = {
  userId: 0,
  mailaddress: "",
  familyName: "",
  firstName: "",
  organization: "",
  systemAdminFlg: "",
};

const UserDetail: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  const {state, dispatch} = React.useContext(ApolloContext);
  const {data, setmsg} = useContext(ApolloMessage);

  const [openrole, setRoleOpen] = React.useState(false);
  const [users, setUsers] = React.useState<DetailUser>(initUser);
  const [roles, setRoles] = React.useState<RoleInfo[]>([]);

  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_OPERATOR);

  // 0: 新規, アカウントグループID: 編集
  const {userid} = useParams<{userid: string}>();
  const processing = useRef(false);
  // 操作ログ仕様変数
  const resultData = useRef<any>(null);
  const resultApi = useRef(-1);
  const logTime = useRef("");
  const actionType = useRef(0); // 0:参照 1:新規 2:更新 3:削除 4:アップロード

  const handleDelete = () => {

    const loginUserId = state.userprofile.userId;
    if (Number(userid) === loginUserId) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0",UI_USER_DETAIL,"V","0"),
        }
      });
      return;
    }
    if (processing.current) return;
    processing.current = true;
    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ(実行)
    resultApi.current = 0;
    // 操作ログアクション(削除)
    actionType.current = 3;
    writeLog();

    let url = `${apollo_user_path}${userid}`;
    ApolloAxios.delete(url).then((response) => {
      // 操作ログ(成功)
      resultApi.current = 1;
      resultData.current = response.data.current;
      
      roles.forEach(function (role: any) {
        let url = `${get_apollo_role_path}/${role.roleId}/${userid}`;

        ApolloAxios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          }
        }).then((response) => {

          // ログイン中の自ユーザーアカウントを削除したならログアウトさせる
          if (Number(userid) === loginUserId) {
            dispatch({
              type: "clearAccount",
              payload: {
                ...state,
              }
            });

            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: "success",
                message: GetMessage("0",UI_USER_DETAIL,"I","0"),
              }
            });
            return history.push(signin_path);
          }

        }).catch(err => {
          // 操作ログ(失敗)
          resultApi.current = 9;
          // 認証期間切れ判定とエラーメッセージ表示
          if (!ApolloExpired(err, GetMessage("0",UI_USER_DETAIL,"E","0"), data, setmsg, history)) {
            // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
          }
        });
      })

      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: "削除に成功しました"
        }
      });
      history.push('/users');
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_USER_DETAIL,"E","1"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
      // 処理終了時にprocessingをfalseにする
      processing.current = false;
    });
  };

  React.useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })
    var url = `${apollo_user_path}${userid}`;
    ApolloAxios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then((response1) => {
      setmsg({
        type: "all",
        payload: {
          ...data,
          loading: false,
        }
      });
      setUsers(response1.data.result);
      setRoles(response1.data.result.userRoleInfo);
    }).catch((err) => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_USER_DETAIL,"E","2"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [])

  const handelGoback = () => {
    const url = "/users";
    history.push(url);
  };

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 項目リスト
    var key = "";
    var beforeValue = "";
    var afterValue = "";
    switch (actionType.current) {
      case 0: // 参照
        break;
      case 1: // 新規
        break;
      case 2: // 更新
        break;
      case 3: // 削除
        key = "論理削除フラグ";
        beforeValue = "0";
        afterValue = "1";
        break;
      case 4: // アップロード
        break;
      default: // 不明
        key = "不明";
    }
    // 項目リスト
    const itemList: ItemList[] = [];
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: 0, // アカウントグループID
      accountGroupName: "", // アカウントグループ名
      accountID: 0, // 広告主アカウントID
      accountName: "", // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: "ユーザー詳細画面", // 操作画面名称 〇〇画面
      category: "ユーザー", // 操作対象 キャンペーン / セグメント etc...
      actionType: actionType.current === 0 ? "参照" : actionType.current === 1 ? "作成" : actionType.current === 2 ? "更新" : actionType.current === 3 ? "削除" : actionType.current === 4 ? "アップロード" : "不明", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : userid + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "ユーザーID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };
  
  const products = [
    {name: 'ユーザーID', desc: '', value: users.userId, isDisplay: true},
    {name: 'メールアドレス', desc: '', value: users.mailaddress, isDisplay: true},
    {name: 'ユーザー名（姓）', desc: '', value: users.familyName, isDisplay: true},
    {name: 'ユーザー名（名）', desc: '', value: users.firstName, isDisplay: true},
    {name: '所属組織', desc: '', value: users.organization, isDisplay: true},
    {name: 'システム管理権限', desc: '', value: users.systemAdminFlg === "1" ? "有" : "無", isDisplay: isAuthorization},
    {name: 'システム運用権限', desc: '', value: users.systemAdminFlg === "2" ? "有" : "無", isDisplay: isAuthorization},
  ];

  const attention: Attention = {
    message: <>
      {"※画面に表示されていないアカウントグループがあった場合、"}
      <br />
      {"　そのアカウントグループからも完全に削除されます。"}
      <br />
      {"　意図しない削除が行われないよう十分にご注意下さい。"}
    </>,
    style: {color: "red"}
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_GROUP_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs bread_no={31} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={userid}
                           platform={""}/>
        <Tooltip title="ユーザー編集" placement="top">
          <Fab color="primary" aria-label="edit" className={classes.fab2}>
            <Link to={"/useredit/" + userid} className={classes.link}>
              <EditIcon/>
            </Link>
          </Fab>
        </Tooltip>
        <Tooltip title="ユーザー削除" placement="top">
          <Fab color="primary" aria-label="del" className={classes.fab}>
            <DeleteButton handleDelete={handleDelete} title="ユーザー削除" text={'削除しますか？'} attention={attention}/>
          </Fab>
        </Tooltip>

        <React.Fragment>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3} style={{marginBottom: "5px"}}>
                {products?.map((product, index) => {
                  return (
                    product.isDisplay
                    ? <React.Fragment key={index}>
                      <Grid item xs={6}>
                        <Typography>{product.name}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>{product.value}</Typography>
                      </Grid>
                    </React.Fragment>
                    : null
                  )
                })}
              </Grid>
              <Divider/>
              <Typography variant="subtitle1" gutterBottom style={{marginTop: "5px"}}>
                所有しているロール
              </Typography>
              <IconButton aria-label="expand row" size="small" onClick={() => setRoleOpen(!openrole)}>
                {openrole ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
              </IconButton>
              <Collapse in={openrole} timeout="auto" unmountOnExit>
                <TableContainer component={Paper} square variant="outlined">
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">アカウントグループ名</TableCell>
                        <TableCell align="center">ロール</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {roles.map((role) => (
                        <TableRow>
                          <TableCell align="center">{role.accountGroupName}</TableCell>
                          <TableCell align="center">{role.name}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Collapse>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <Button
                variant="contained"
                color="primary"
                onClick={handelGoback}
                className={classes.button}
              >
                戻る
              </Button>
            </CardActions>
          </Card>
        </React.Fragment>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
};

export default UserDetail;
